import * as React from "react"
import { Moon, Sun } from "lucide-react"

import { useTheme } from "@/components/ThemeProvider"
import { Button } from "@/components/ui/button"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const toggleTheme = () => {
    // This will cycle through 'light' and 'dark'.
    // If the theme was 'system', it will switch to the opposite of the system theme.
    setTheme(theme === "dark" ? "light" : "dark")
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      className="rounded p-2 relative text-foreground after:absolute after:-inset-1 after:min-w-[44px] after:min-h-[44px] after:content-[''] sm:after:hidden"
      aria-label="Toggle theme"
    >
      <Sun className="h-4 w-4 md:h-5 md:w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 md:h-5 md:w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
